import { ColoresGlobales } from '../classes/styleClasses';
import { getCssVariable } from './styleUtils';
import config from '../config.json';

export function ubicarDivSegunCoordenada(el, topCoo, leftCoo, tam){
    const { innerHeight: alto, innerWidth: ancho } = window;
    const medioAlto = alto/2;
    const medioAncho = ancho/2;
    const medioTam = tam/2;
    el.style.top = topCoo +  (tam/2) * topCoo > medioAlto ? -1 : 1;    
    
    if (topCoo > medioAlto){
        el.style.bottom = (alto - topCoo + medioTam) + "px";        
    } else {
        el.style.top = (topCoo + medioTam) + "px";        
    }

    if (leftCoo > medioAncho){
        el.style.right = (ancho - leftCoo + medioTam) + "px";        
    } else {
        el.style.left = (leftCoo + medioTam) + "px";        
    }
}

export function destroyElement(id){
    document.getElementById(id)?.remove();
}

export function destroyElementsOnStartStationary(){
    destroyElement(config.domIds.avisoCoordenadaCopiadaId);
    destroyElement(config.domIds.circuloCoordenadaCopiadaId);
    destroyElement(config.domIds.avisoCoordenadaNoCopiadaId);
}

export function descargarArchivo(archivo, nombre) {
    const link = document.createElement("a");
    link.setAttribute("href", archivo);
    link.setAttribute("download", nombre);
    document.body.appendChild(link); // Required for FF
    link.click();
}

export function changeDisplayClass(nombreClase, display){
    const elems = document.querySelectorAll(`.${nombreClase}`);
    elems.forEach(elem => {
        elem.style.display = display;
    })
}

export function getColoresGlobales(){
    return new ColoresGlobales(
        getCssVariable(ColoresGlobales.codColorBase),
        getCssVariable(ColoresGlobales.codColorTextoLista),
        getCssVariable(ColoresGlobales.codColorImportante),
        getCssVariable(ColoresGlobales.codColorAceptado)
    )
}

export function fadeOut(el, opacityAct, segundos = 5){
    el.style.opacity = opacityAct;
    setTimeout(() => {
        opacityAct = (opacityAct - 0.01).toFixed(2);
        if (opacityAct > 0){
            fadeOut(el, opacityAct, segundos);
        } else {
            el.style.opacity = opacityAct;
        }
    }, (segundos * 1000) / 100)
}

function actualizarTamano(el, tam, top, left){
    el.style.width = tam + "px";
    el.style.height = tam + "px";
    el.style.top = top - tam / 2 + "px"
    el.style.left = left - tam / 2 + "px"
}

export function reducirTamano(el, tamAct, tamMin, top, left, segundos = 5){
    actualizarTamano(el, tamAct, top, left);
    setTimeout(() => {
        tamAct = tamAct -= 2;
        if (tamAct > tamMin){
            reducirTamano(el, tamAct, tamMin, top, left, segundos);
        } else {
            actualizarTamano(el, tamAct, top, left);            
        }
    }, (segundos * 1000) / 100)
}

export function selectElementContents(el) {
    var body = document.body;
    let range;
    if (document.createRange && window.getSelection) {
        range = document.createRange();
        const sel = window.getSelection();
        sel.removeAllRanges();
        try {
            range.selectNodeContents(el);
            sel.addRange(range);
        } catch (e) {
            range.selectNode(el);
            sel.addRange(range);
        }
    } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
    }
}